<template>
  <div class="health-page">

    <section class="hero">

      <div class="hero-header">
        <div class="hero-title">Личный кабинет пациента</div>
        <div class="hero-subtitle">
          Медицинские документы и направления
        </div>
      </div>

      <!-- актуальные назначения -->
      <div class="hero-message">

        <template v-if="loading">
          <q-skeleton height="90px" class="hero-skeleton" />
        </template>

        <template v-else>
          <q-card class="hero-card">
            <q-card-section class="row items-center no-wrap">

              <q-icon
                name="info"
                size="26px"
                class="hero-icon"
              />

              <div class="hero-text">
                <div class="hero-card-title">
                  Актуальные направления
                </div>
              </div>
            </q-card-section>
            <q-card-section>
              <q-card
                v-for="action in filteredDocuments"
                :key="action.id_document"
                class="quick-item"
                :class="{
                  'q-mb-sm': filteredDocuments.length > 1,
                }"
              >
                <q-card-section class="row items-center no-wrap"
                @click="openInNewTab(action)">

                  <div class="quick-icon-box">
                    <q-icon
                      name="assignment"
                      size="26px"
                      class="quick-icon"
                    />
                  </div>

                  <div class="quick-text">
                    <div class="quick-title">
                      {{ action.doc_name }}
                    </div>
                    <div class="quick-subtitle">
                      {{ action.date_doc }}
                    </div>
                  </div>

                  <q-icon
                    name="open_in_new"
                    size="20px"
                    class="quick-arrow"
                  />
                </q-card-section>
              </q-card>
            </q-card-section>
          </q-card>
        </template>

      </div>
    </section>

    <section class="main-content">
      <div class="quick-list">

        <template v-if="loading">
          <q-skeleton
            v-for="n in 4"
            :key="n"
            height="70px"
            class="rounded-lg q-mb-md"
          />
        </template>

        <template v-else>
          <q-card class="quick-item" v-if="polis.length">
            <q-card-section class="row items-center no-wrap">

              <div class="quick-icon-box">
                <q-icon
                  name="badge"
                  size="26px"
                  class="quick-icon"
                />
              </div>

              <div class="quick-text">
                <div class="quick-title">
                  Полис ОМС
                </div>
                <div class="quick-subtitle">
                  <p class="q-mb-none text-bold">{{ polis }}</p>
                  <canvas ref="barcodeCanvas"></canvas>
                </div>
              </div>

              <q-icon
                name="content_copy"
                size="20px"
                class="quick-arrow"
                @click="copyPolice(polis)"
              />
            </q-card-section>
          </q-card>
          <!-- <q-card
            v-for="action in actions"
            :key="action.title"
            class="quick-item"
          >
            <q-card-section class="row items-center no-wrap">

              <div class="quick-icon-box">
                <q-icon
                  :name="action.icon"
                  size="26px"
                  class="quick-icon"
                />
              </div>

              <div class="quick-text">
                <div class="quick-title">
                  {{ action.title }}
                </div>
                <div class="quick-subtitle">
                  {{ action.subtitle }}
                </div>
              </div>

              <q-icon
                name="chevron_right"
                size="20px"
                class="quick-arrow"
              />
            </q-card-section>
          </q-card> -->
        </template>

      </div>

      <!-- <div class="section-title q-mt-xl">
        Оказанные услуги
      </div>

      <q-card class="block-card">
        <q-card-section v-if="!loading">
          <div
            v-for="service in services"
            :key="service.id"
            class="list-row"
          >
            <div>
              <div class="row-title">
                {{ service.title }}
              </div>
              <div class="row-subtitle">
                {{ service.date }}
              </div>
            </div>

            <q-btn flat dense icon="chevron_right" />
          </div>
        </q-card-section>

        <q-card-section v-else>
          <q-skeleton height="120px" class="rounded-lg" />
        </q-card-section>
      </q-card> -->

      <div class="section-title q-mt-xl">
        Медицинская карта
      </div>

      <div class="row q-col-gutter-md">
        <div
          v-for="item in medSections"
          :key="item.title"
          class="col-12 col-md-6"
        >
          <q-card class="med-card" v-if="!loading">
            <q-card-section
              class="row items-center justify-between cursor-pointer"
              @click.stop="goToDocuments"
            >
              <div>
                <div class="row-title">
                  {{ item.title }}
                </div>
                <div class="row-subtitle">
                  {{ item.subtitle }}
                </div>
              </div>

              <q-icon name="chevron_right" size="22px" />
            </q-card-section>
          </q-card>

          <q-skeleton
            v-else
            height="70px"
            class="rounded-lg"
          />
        </div>
      </div>

      <div class="section-title q-mt-xl">
        Адреса филиалов
      </div>

      <q-card class="block-card">
        <q-card-section v-if="!loading">
          <div class="map-box q-mt-md">
              <CenterMap
                v-for="map in maps"
                :key="map.name"
                :name="map.name"
                :address="map.address"
                :building-coords="map.buildingCoords"
                :entrance-coords="map.entranceCoords"
              />
          </div>
        </q-card-section>

        <q-card-section v-else>
          <q-skeleton height="160px" class="rounded-lg" />
        </q-card-section>
      </q-card>
    </section>
  </div>
</template>

<script lang="ts">
import {
  ref,
  onMounted,
  reactive,
  nextTick,
  computed,
} from 'vue';
import { useQuasar, copyToClipboard } from 'quasar';
import CenterMap from '@/components/CenterMap.vue';
// eslint-disable-next-line import/no-cycle
import { useAuthStore } from '@/store/auth/authModule';
// eslint-disable-next-line import/no-cycle
import { useEcoHospitalStore } from '~store/ecohospital/ecohospitalModule';
// eslint-disable-next-line import/no-cycle
import router from '@/router';
// eslint-disable-next-line import/no-cycle
import { useMainStore } from '@/store';

export default { name: 'HealthPageFull' };
</script>

<script setup lang="ts">
const $q = useQuasar();

const loading = ref(true);
const polis = ref<string>('');
const barcodeCanvas = ref<HTMLCanvasElement | null>(null);
const ecoStore = useEcoHospitalStore();

type UserDocument = {
  att_type: number;
  checksum: number;
  date_doc: string;
  datebegin: string;
  doc_name: string;
  doc_type: number;
  file_ext: string;
  id_document: number;
  id_patient: number;
  is_napravlenie: number;
  tg: string;
};
const documents = ref<UserDocument[]>([]);

polis.value = useAuthStore().currentUser?.oms_polis || '';

type Map = {
  name: string
  address: string
  buildingCoords: number[],
  entranceCoords?: number[] | null
}

const copyPolice = async (value: string) => {
  await copyToClipboard(value);
  $q.notify({
    message: 'Номер полиса скопирован в буфер обмена',
    color: 'positive',
    icon: 'check',
  });
};

const maps = reactive<Map[]>([
  {
    name: 'Филиал на ул. Достоевская',
    address: 'ул. Достоевского, 40-44',
    buildingCoords: [59.922327, 30.345347],
    entranceCoords: [59.922467, 30.345367],
  },
  {
    name: 'Филиал на Ладожской',
    address: 'Заневский проспект, 65 к5, этаж 4',
    buildingCoords: [59.932530, 30.433892],
    entranceCoords: [59.932561, 30.433579],
  },
  {
    name: 'Филиал на Звездной',
    address: 'просп. Юрия Гагарина, 65',
    buildingCoords: [59.842066, 30.335850],
    entranceCoords: [59.842121, 30.335983],
  },
]);

// eslint-disable-next-line no-promise-executor-return
const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

onMounted(async () => {
  // await delay(1500);
  try {
    loading.value = true;
    documents.value = await ecoStore.getDocuments();
  } catch (error) {
    console.error('Ошибка при загрузке документов:', error);
  } finally {
    loading.value = false;
  }
  nextTick(() => {
    const { PDF417 } = window as any;

    if (PDF417 && polis.value.length) {
      PDF417.draw(
        polis.value,
        barcodeCanvas.value,
        5,
        4,
        window.devicePixelRatio,
        '#000',
      );
    }
  });
});

const filteredDocuments = computed(
  () => documents.value?.filter((doc) => doc.is_napravlenie === 1),
);

const goToDocuments = () => {
  router.push('/patient-documents');
};

const openInNewTab = async (doc: UserDocument) => {
  const path = await ecoStore.getFilePath(doc.id_document);
  if (path[0].hash) {
    window.open(`https://host2.medsafe.tech/${path[0].hash}`, '_tab');
  } else {
    useMainStore().showMessage('Извините, не смогли найти документ.');
  }
};

const actions = [
  {
    title: 'Запись к врачу',
    subtitle: 'Выбрать специалиста',
    icon: 'event_available',
  },
  {
    title: 'Анкетирование',
    subtitle: 'Заполнить опрос',
    icon: 'ballot',
  },
  // {
  //   title: 'Моя поликлиника',
  //   subtitle: 'Адрес и контакты',
  //   icon: 'local_hospital',
  // },
];

const services = [
  {
    id: 1,
    title: 'Приём терапевта',
    date: '10 февраля 2026',
    place: 'Поликлиника №12',
  },
  {
    id: 2,
    title: 'Флюорография',
    date: '22 января 2026',
    place: 'Диагностический центр',
  },
];

const medSections = [
  {
    title: 'Справки и заключения',
    subtitle: 'Выписки, мед. заключения',
  },
  {
    title: 'Направления',
    subtitle: 'Активные и архивные',
  },
  {
    title: 'Протоколы консультаций',
    subtitle: 'История посещений',
  },
  {
    title: 'Протоколы исследований',
    subtitle: 'Анализы и диагностика',
  },
  // {
  //   title: 'Рецепты',
  //   subtitle: 'Назначенные препараты',
  // },
  // {
  //   title: 'Больничные листы',
  //   subtitle: 'Электронные листы нетрудоспособности',
  // },
];
</script>

<style scoped>
.health-page {
  min-height: 100%;
  font-family: Inter, system-ui, sans-serif;

  background: linear-gradient(
    180deg,
    #0b2d6b 0%,
    #144aa0 25%,
    #f6f7fb 65%,
    #f6f7fb 100%
  );
}

.hero {
  padding: 22px 20px 26px;
  background: transparent;
  border-bottom-left-radius: 26px;
  border-bottom-right-radius: 26px;
}

.hero-header {
  max-width: 1150px;
  margin: 0 auto;
}

.hero-title {
  font-size: 22px;
  font-weight: 700;
  color: white;
}

.hero-subtitle {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.75);
  margin-top: 4px;
}

.hero-message {
  margin-top: 18px;
}

.hero-card {
  border-radius: 18px;
  padding: 4px;
  max-width: 1150px;
  margin: 0 auto;
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.25);

  backdrop-filter: blur(10px);
  box-shadow: none;
}

.hero-icon {
  color: white;
}

.hero-text {
  flex: 1;
  margin-left: 14px;
}

.hero-card-title {
  font-size: 15px;
  font-weight: 600;
  color: white;
}

.hero-card-subtitle {
  font-size: 13px;
  margin-top: 2px;
  color: rgba(255, 255, 255, 0.8);
}

.hero-arrow {
  color: rgba(255, 255, 255, 0.85);
}

.hero-skeleton {
  border-radius: 18px;
  opacity: 0.35;
}

.main-content {
  padding: 18px 20px 40px;
  max-width: 1150px;
  margin: 0 auto;
  background: white;
  border-radius: 26px;
  box-shadow: 0 -8px 30px rgba(0, 0, 0, 0.08);
}

.section-title {
  font-size: 15px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 12px;
}

.top-header {
  padding: 22px;
  background: white;
  border-bottom: 1px solid #e6e8ef;
}

.page-title {
  font-size: 22px;
  font-weight: 600;
}

.page-subtitle {
  font-size: 14px;
  color: #6b7280;
  margin-top: 4px;
}

.content {
  max-width: 1150px;
  margin: 0 auto;
  padding: 10px 20px 40px;
}

.block-card,
.action-card,
.med-card,
.message-card {
  background: white;
  border-radius: 18px;
  border: 1px solid #eef0f6;
}

.card-title {
  font-size: 15px;
  font-weight: 600;
}

.card-subtitle {
  font-size: 13px;
  color: #6b7280;
}

.msg-icon {
  color: #2563eb;
}

.action-icon {
  color: #2563eb;
}

.action-card {
  cursor: pointer;
  transition: 0.2s;
}

.action-card:hover {
  transform: translateY(-2px);
}

.list-row {
  padding: 14px 0;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.list-row:last-child {
  border-bottom: none;
}

.row-title {
  font-size: 15px;
  font-weight: 500;
}

.row-subtitle {
  font-size: 13px;
  color: #6b7280;
}

.map-box {
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  overflow: hidden;
}

.map-placeholder {
  background: #e9ecf5;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  color: #555;
}

.rounded-lg {
  border-radius: 18px;
}

.quick-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-top: 1rem;
}

.quick-item {
  background: white;
  border-radius: 18px;
  border: 1px solid #eef0f6;
  cursor: pointer;
}

.quick-icon-box {
  width: 46px;
  height: 46px;
  border-radius: 14px;
  background: #eef4ff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.quick-icon {
  color: #2563eb;
}

.quick-text {
  flex: 1;
  margin-left: 14px;
}

.quick-title {
  font-size: 15px;
  font-weight: 600;
}

.quick-subtitle {
  font-size: 13px;
  color: #6b7280;
}

.quick-arrow {
  color: #2563eb;
}
canvas {
  width: auto;
  height: auto;
}
@media (max-width: 768px) {
  canvas {
    width: 80%;
    height: auto;
  }
}
</style>
